import { render, staticRenderFns } from "./CircleProgressValue.vue?vue&type=template&id=3bf1498d&"
import script from "./CircleProgressValue.vue?vue&type=script&lang=js&"
export * from "./CircleProgressValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports